module.exports = __webpack_public_path__ + "img/4.7dde89d2.jpg";